import ApiService from '../../../../../services/ApiService'

export default {
  props: {
    title: String,
    calibrationPatternIdProp: Number,
    metric: Object,
  },

  created() {
    this.calibrationPatternId = this.calibrationPatternIdProp
    this.getCalibrationMetrics()

    if (this.metric) {
      this.currentMetric = this.metric
      this.calibrationMetricId = this.metric.calibrationMetricsId
      this.isEditing = true
    }
  },

  data: () => ({
    step: 0,
    errorMessage: '',
    loading: false,
    calibrationMetricsLoading: false,
    firstValid: true,
    alterDialog: false,
    changedData: false,
    isEditing: false,
    error: false,
    calibrationPatternId: null,
    calibrationMetricId: null,
    calibrationMetrics: [],
    currentMetric: {
      id: 0,
      resolution: null,
      calibrationMetricId: null,
    },
    calibrationMetricRulles: [(v) => !!v || 'Métrica requerida'],
    resolutionRules: [(v) => !!v || 'Resolucação requerida'],
    apiService: new ApiService(),
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Dados gerais'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$emit('close')
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.submit()
        }
      } else {
        this.closeDialog()
      }
    },

    async submit() {
      this.loading = true

      const calibrationPatternMetric = {
        Id: this.currentMetric.id,
        Name: this.currentMetric.Name,
        Resolution: this.currentMetric.resolution,
        CalibrationMetricsId: this.calibrationMetricId,
        CalibrationPatternId: this.calibrationPatternId,
      }

      let url = 'calibrationPatternMetrics/add'

      if (this.isEditing) {
        url = 'calibrationPatternMetrics/edit'
      }

      await this.apiService
        .post(url, calibrationPatternMetric)
        .then(() => {
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.changedData = false
    },

    async getCalibrationMetrics() {
      await this.apiService.get('CalibrationMetrics/list').then((response) => {
        this.calibrationMetrics = response.content
      })
    },
  },

  watch: {
    currentMetric: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
